module.exports = __webpack_public_path__ + "static/img/noche.7cd6488.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/noche.png
// module id = XOrY
// module chunks = 1